// ---------------------------------------------------------------------------
// ConsumerTypeStep — Card selection for consumer type
// ---------------------------------------------------------------------------

import { memo, useCallback } from 'react';
import { OptionCard } from '@/components/shared/OptionCard';
import { StepHeading } from '@/components/shared/StepHeading';
import { t } from '@/i18n';
import { useCollectedData } from '@/hooks/useCollectedData';
import type { StepProps } from '@/types/steps';
import { getStepIcon } from '@/utils/stepIcons';
import styles from './ConsumerTypeStep.module.css';

export const ConsumerTypeStep = memo(function ConsumerTypeStep({
  stepId,
  options,
  onSubmit,
  isSubmitting,
}: StepProps) {
  const collectedData = useCollectedData();
  const previousLct = (collectedData['local_consumer_type_id'] as string | undefined) ?? '';
  const handleSelect = useCallback(
    (id: string) => {
      if (isSubmitting) return;
      onSubmit({ local_consumer_type_id: id });
    },
    [onSubmit, isSubmitting],
  );

  return (
    <>
      <StepHeading
        title={t('steps.local_consumer_type.title')}
        subtitle={t('steps.local_consumer_type.subtitle')}
        icon={getStepIcon(stepId)}
      />
      <div
        className={styles['list']}
        role="listbox"
        aria-label={t('steps.local_consumer_type.title')}
      >
        {options.options.map((o) => (
          <OptionCard
            key={o.id}
            id={o.id}
            name={o.name}
            description={o.description || undefined}
            isSelected={o.id === previousLct}
            onClick={handleSelect}
          />
        ))}
      </div>
    </>
  );
});
